import { OpDelete } from "src/assets/icons";
import OpIconButton from "src/components/OpIconButton";
import { useDialogProviderContext } from "src/features/DialogProvider";
import { useTranslation } from "src/hooks";

function DeleteButton() {
  const { tc } = useTranslation("common");
  const { setIsOpen } = useDialogProviderContext();

  return (
    <OpIconButton
      title={tc("delete")}
      url={OpDelete}
      onClick={() => setIsOpen(true)}
    />
  );
}

export default DeleteButton;
